<template>
  <div class="default-layout-ui">
    <slot />
  </div>
</template>
